import { connect } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import * as Actions from '../../actions/actions';

const RouteSummaryGridPanel = ({ routeSummaryData, pagination, sorting, filters, customers, ...props }) => {

    const enrichedRows = (routeSummaryData || []).map(row => ({
        ...row,
        filter_date: row.scan_date || '',
        filter_customer: (() => {
            const c = (customers || []).find(c => c.customer_id === filters.customer);
            return c ? c.customer_name : (filters.customer || '');
        })(),
        filter_dc: row.dc_name || filters.dc || ''
    }));

    const columns = [
        { field: 'filter_date', headerName: 'Date', width: 110 },
        { field: 'filter_customer', headerName: 'Customer', width: 160 },
        { field: 'filter_dc', headerName: 'DC', width: 160 },
        { field: 'local_route', headerName: 'Route', width: 100 },
        { field: 'dock_door', headerName: 'Door Assigned?', width: 130 },
        { field: 'loaded_count', headerName: 'Pallets Loaded', width: 130, type: 'number' },
        { field: 'expected_count', headerName: 'Pallets Expected', width: 140, type: 'number' },
        {
            field: 'completion_pct',
            headerName: '% Loaded',
            width: 100,
            type: 'number',
            valueFormatter: (params) => `${params.value || 0}%`
        },
        { field: 'total_throughput', headerName: 'Total Pallets (Smart + Non-smart)', width: 260, type: 'number' },
        { field: 'wrong_door_count', headerName: 'Wrong Door Count', width: 150, type: 'number' },
        { field: 'out_of_order_count', headerName: 'Out of Order Count', width: 160, type: 'number' }
    ];

    const handleSortModelChange = (model) => {
        if (model.length > 0) {
            const { field, sort } = model[0];
            props.updateSort(field, sort);
        }
    };

    const handlePageChange = (newPage) => {
        props.updatePage(newPage);
    };

    return (
        <div className="dashboardData-panel">
            <div className="duolift-device-detail-card" style={{ width: "100%" }}>
                <div className="detail-card-header">
                    <h3 style={{ paddingTop: '10px' }}>ROUTE SUMMARY</h3>
                </div>
                <div className="duolift-device-detail-card-body">
                    <div style={{ height: '440px', width: '100%' }}>
                        <DataGrid
                            rows={enrichedRows}
                            columns={columns}
                            pageSize={pagination.pageSize}
                            rowsPerPageOptions={[50]}
                            page={pagination.page}
                            rowCount={pagination.totalCount}
                            paginationMode="server"
                            sortingMode="server"
                            onSortModelChange={handleSortModelChange}
                            onPageChange={handlePageChange}
                            getRowId={(row) => row.id}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    routeSummaryData: state.loadValidationDashboard.routeSummaryData,
    pagination: state.loadValidationDashboard.pagination.routeSummary,
    sorting: state.loadValidationDashboard.sorting.routeSummary,
    filters: state.loadValidationDashboard.filters,
    customers: state.edgePCs.customers || []
});

const mapDispatchToProps = (dispatch) => ({
    updateSort: (sortBy, sortOrder) => dispatch(Actions.UPDATE_ROUTE_SUMMARY_SORT(sortBy, sortOrder)),
    updatePage: (page) => dispatch(Actions.UPDATE_ROUTE_SUMMARY_PAGE(page))
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteSummaryGridPanel);
